<template>
  <div class="col-sm-3 product-bascet">
    <div class="row">
      <div class="col-sm-12 product-bascet-box">
        <div class="product-bascet-content">
          <div class="product-bascet-titr d-flex">
            <h6>سبد خرید شما از {{business.title}}</h6>
            <i class="icon-shopping"></i>
            <span>0</span>
          </div>
          <div class="d-flex product-bascet-alert">
            <h6>سبد خرید خالی است</h6>
          </div>

          <div class="border col-12"></div>

          <div class="product-bascet-detailAll d-flex">
            <div class="product-bascet-detail d-flex">
              <p class="detail-p">جمع مبلغ خالص</p>
              <p class="detail-p">تخفیف</p>
              <p class="detail-p">مالیات ( %)</p>
              <p class="detail-p">هزینه ارسال</p>
            </div>
            <div class="product-bascet-detail align-items d-flex">
              <p class="detail-p">0</p>
              <p class="detail-p">0</p>
              <p class="detail-p">0</p>
              <p class="detail-p">رایگان</p>
            </div>
            <div class="product-bascet-detail d-flex">
              <p class="detail-p">تومان</p>
              <p class="detail-p">تومان</p>
              <p class="detail-p">تومان</p>
              <p class="detail-p"></p>
            </div>
          </div>

          <div class="product-bascet-pay d-flex">
            <div class="product-bascet-detail d-flex">
              <p class="detail-p">جمع مبلغ خالص</p>
            </div>
            <div class="product-bascet-detail align-items d-flex">
              <p class="detail-p">0</p>
            </div>
            <div class="product-bascet-detail d-flex">
              <p class="detail-p">تومان</p>
            </div>
          </div>

          <div class="product-bascet-button d-flex">
            <button>بررسی نهایی</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let business = {};

export default {
  name: "ShoppingBasket",
  props: ["data"],
  computed: {
    business() {
      if (localStorage.getItem("business")) {
        business = JSON.parse(localStorage.getItem("business"));
      }
      return business;
    },
  },
};
</script>